<template>
  <view class="container">
    <image class="icon" src="{{trainIconUrl}}"></image>
    <view class="text">{{title}}</view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    props: {
      title: {
        type: String,
        value: ''
      }
    },
    data: {
      trainIconUrl: 'https://ut-static.udache.com/webx/sfc/dItks2UdP8PydrvXemjb0.png',
    },
  })
</script>

<style lang='stylus' scoped>
.container
  display flex
  flex-direction column
  align-items center
  font-family PingFangSC-Medium
  font-size 24px
  font-weight normal
  line-height 1
  letter-spacing 0px
  color #000000
  .icon
    width 60px
    height 60px
    margin-bottom 13px
  .text
    min-height 30px
    line-height 30px
    max-width 100%
    word-break break-all

</style>

<script name='json'>
  module.exports = {
    component: true,
  }
</script>

